// TODO https://github.com/laboratoriobridge/pec/issues/35251: unificar com o AcompanhamentoExpandableFilterContainer e
// aplicar as melhorias de comportamento pendentes levantadas na issue
import { css } from '@emotion/react'
import { Button, Flow, Icon, Text } from 'bold-ui'
import { useIsOverflowing } from 'bold-ui/lib/hooks'
import { MutableRefObject, ReactNode, useEffect, useRef, useState } from 'react'

interface FilterExpandableContainerProps<T> {
  children: ReactNode
  resetDependency: T
  footer?: ReactNode
}

export function FilterExpandableContainer<T>(props: Readonly<FilterExpandableContainerProps<T>>) {
  const { children, footer, resetDependency } = props

  const [isExpanded, setIsExpanded] = useState(false)

  const styles = createStyles(isExpanded)

  const containerRef = useRef<HTMLDivElement>(null)
  const isExpandable = useIsOverflowing(containerRef as MutableRefObject<HTMLElement>, 'horizontal')

  const isTruncated = isExpandable && !isExpanded
  const isToggleEnabled = isExpandable || isExpanded
  const iconAngle = isExpanded ? 'angleUp' : 'angleDown'
  const buttonText = isExpanded ? 'Esconder filtros' : 'Exibir filtros'

  const toggleExpanded = () => {
    if (isToggleEnabled) {
      setIsExpanded((current) => !current)
    }
  }

  useEffect(() => {
    setIsExpanded(false)
  }, [resetDependency])

  return (
    <Flow direction='vertical' gap={0.5} style={styles.root}>
      <div css={styles.row}>
        <div ref={containerRef} css={styles.container}>
          <div css={styles.content}>{children}</div>
        </div>

        {isTruncated && (
          <Text aria-hidden style={styles.ellipsis}>
            …
          </Text>
        )}

        {isToggleEnabled && (
          <Button size='small' skin='ghost' onClick={toggleExpanded} style={styles.button}>
            <Flow direction='horizontal' alignItems='center' gap={0.5}>
              <Text>{buttonText}</Text>
              <Icon icon={iconAngle} />
            </Flow>
          </Button>
        )}
      </div>
      {footer}
    </Flow>
  )
}

const createStyles = (isExpanded: boolean) => ({
  root: css`
    width: 100%;
  `,
  row: css`
    display: flex;
    align-items: center;
    min-width: 0;
  `,
  container: css`
    flex: 1 1 0%;
    min-width: 0;
    overflow: hidden;
  `,
  content: css`
    width: ${isExpanded ? 'auto' : 'max-content'};
  `,
  ellipsis: css`
    flex-shrink: 0;
  `,
  button: css`
    flex-shrink: 0;
    margin-left: 0.25rem;
  `,
})
